<template>
    <div>
        <div class="text-left mt-4">
            <footer-text text="Навигация"/>
        </div>
        <div>
            <footer-links/>
        </div>
    </div>
</template>
<script>

import FooterLinks from '@/components/footer/FooterLinks.vue';
import FooterText from '@/components/footer/FooterText.vue';
export default {
    name: 'FooterNavigation',
    components: {
        FooterLinks,
        FooterText
    }
}
</script>